<template>
    <div>
        <q-tabs
            v-model="tab"
            class="bg-grey-4 text-primary"
            align="justify"
            dense
            inline-label
        >
            <q-tab
                name="production"
                icon="fas fa-conveyor-belt-alt"
                :label="$t('Production')"
            />
            <q-tab
                name="downtime"
                icon="fas fa-engine-warning"
                :label="$t('Downtime')"
            />
        </q-tabs>

        <q-tab-panels
            v-model="tab"
            animated
            swipeable
            vertical
            transition-prev="jump-right"
            transition-next="jump-left"
        >
            <q-tab-panel name="production">
                <production-report :asset-id="assetId"></production-report>
            </q-tab-panel>

            <q-tab-panel name="downtime">
                <downtime-report :asset-id="assetId"></downtime-report>
            </q-tab-panel>
        </q-tab-panels>
    </div>
</template>

<script>
// vue
import { mapGetters } from 'vuex';
// app components
import BreadcrumbsManager from '@mixins/BreadcrumbsManager.vue';
import ProductionReport from './ProductionReport.vue';
import DowntimeReport from './DowntimeReport.vue';

export default {
    name: 'AssetReports',
    components: { ProductionReport, DowntimeReport },
    mixins: [BreadcrumbsManager],
    props: {
        assetId: {
            type: [Number, String],
            required: true
        },
        facilityId: {
            type: [Number, String],
            required: true
        }
    },
    mounted() {
        // set breadcrumbs
        const asset = this.getAsset(this.assetId);
        const facility = this.getFacility(this.facilityId);
        this.setBreadcrumbs([
            {
                label: this.$t('Facilities'),
                route: {
                    name: 'facility_list'
                }
            },
            {
                label: facility.name,
                route: {
                    name: 'facility_dashboard',
                    params: {
                        facilityId: facility.id
                    }
                }
            },
            {
                label: asset.name,
                route: {
                    name: 'asset_dashboard',
                    params: {
                        assetId: asset.id,
                        facilityId: facility.id
                    }
                }
            },
            {
                label: this.$t('Reports')
            }
        ]);
    },
    data() {
        return {
            // active tab
            tab: 'production'
        };
    },
    computed: {
        ...mapGetters({
            getAsset: 'facilities/getAsset',
            getFacility: 'facilities/getFacility'
        })
    }
};
</script>

<style lang="scss" scoped></style>
